<template>
    <div class="document-details">
      <h1 class="mt-2 mb-4">{{ document.title }}</h1>
<p class="mess-box">Материал справочника. Перед применением проверьте редакцию и адаптируйте шаблон к порядку работы вашей организации.</p>
      <div class="mess-box">{{ document.description }}</div>
      <a
        :href="'https://api.labhub.online/' + document.file_url"
        download
        class="download-button"
      >
        <i class="pi pi-file-word"></i> Скачать
      </a>
      <h3 class="line block mt-6 mb-4">Онлайн просмотр</h3>
      <div v-if="loading" class="loading-spinner">
        <ProgressSpinner />
      </div>
      <div v-else class="document-viewer" v-html="documentContent"></div>
    </div>
  </template>
  
  <script>
  import http from "@/http";
  import mammoth from 'mammoth';
  import ProgressSpinner from 'primevue/progressspinner';
  
  export default {
    components: {
      ProgressSpinner
    },
    data() {
      return {
        document: {},
        documentContent: null,
        loading: true
      };
    },
    async created() {
      await this.fetchDocumentDetails();
      await this.loadDocumentContent();
    },
    methods: {
      async fetchDocumentDetails() {
        try {
          const response = await http.get(`/catalog/document_files/${this.$route.params.id}`);
          this.document = response.data;
        } catch (error) {
          console.error("Error fetching document details:", error);
        }
      },
      async loadDocumentContent() {
        try {
          const response = await fetch(`https://api.labhub.online/${this.document.file_url}`);
          const arrayBuffer = await response.arrayBuffer();
          const result = await mammoth.convertToHtml({ arrayBuffer });
          this.documentContent = result.value;
        } catch (error) {
          console.error("Error loading document content:", error);
        } finally {
          this.loading = false;
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .document-details .mess-box {
    font-size: 16px;
    margin-bottom: 20px;
  }
  .document-viewer {
    width: 100%;
    max-height: 600px;
    margin-bottom: 20px;
    border: 1px solid #e5f0ff;
    border-radius: 5px;
    padding: 20px;
    background-color: #ffffff;
    overflow-y: auto;
  }
  .loading-spinner {
    text-align: center;
    padding: 2rem;
  }
  .download-button {
    display: inline-flex;
    align-items: center;
    padding: 10px 20px;
    background-color: #3fe7de;
    color: white;
    border-radius: 5px;
    text-decoration: none;
    font-size: 16px;
  }
  .download-button i {
    margin-right: 10px;
    font-size: 24px;
  }
  </style>
  